<template>

  <v-list two-line>
    <v-subheader>Flight arrival</v-subheader>
    <v-list-item v-if="value.calculatedTakeOffTime && showCTOT">
      <v-list-item-content>
        <v-list-item-title class="error--text font-weight-bold">
          Calculated take off time
        </v-list-item-title>
        <v-list-item-subtitle class="error--text font-weight-bold">
          {{ value.calculatedTakeOffTime | localMoment('YYYY-MM-DD HH:mm') }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Scheduled
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ value.scheduledTimeArrival | localMoment('YYYY-MM-DD HH:mm') }}<span class="error--text"
            v-if="value.actualArrApIata !== value.arrApIata"> {{ value.arrApIata }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="estArr">
      <v-list-item-content>
        <v-list-item-title>
          Estimated
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ estArr | localMoment('YYYY-MM-DD HH:mm') }}
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item v-if="actArr">
      <v-list-item-content>
        <v-list-item-title>
          Actual
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ actArr | localMoment('YYYY-MM-DD HH:mm') }}<span class="error--text"
            v-if="value.actualArrApIata !== value.arrApIata"> {{ value.actualArrApIata }}</span>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <!-- Duplicated parent component FlightInfoDeparture.vue that has the same data as FlightInfoDeparture.vue -->
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Delay</v-list-item-title>
        <v-list-item-subtitle>
          <template v-if="value.delays && value.delays.length !== 0">
            <li v-for="delay in value.delays">
              {{ delay }}
            </li>
          </template>
          <template v-else>
            -
          </template>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Stand
        </v-list-item-title>
        <v-list-item-subtitle>
          <template v-if="value.arrivalStand">
            {{ value.arrivalStand }}
          </template>
          <template v-else>
            -
          </template>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>
          Gate
        </v-list-item-title>
        <v-list-item-subtitle>
          <template v-if="value.arrivalGate">
            {{ value.arrivalGate }}
          </template>
          <template v-else>
            -
          </template>
        </v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>
  </v-list>

</template>

<script>

export default {
  name: 'FlightInfoArrival',
  props: {
    value: {
      type: Object,
      required: true
    },
    showCTOT: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data: () => ({
  }),
  components: {
  },
  methods: {
  },
  computed: {
    estArr() {
      return (this.value.scheduledTimeArrival !== this.value.timeArrival && !this.actArr) ? this.value.timeArrival : undefined
    },
    actArr() {
      return this.value.onBlockTime
    }
  }
}
</script>
